module.exports = __webpack_public_path__ + "static/media/khetika_qr.b07dd7ba.png";